import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export default function useErrorTranslation() {
  const { t } = useTranslation("errors");

  const tError = useCallback(
    (message: string) => {
      return t(`errors.${message}`);
    },
    [t],
  );

  return tError;
}
